module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_3016.c7e42cd6.png";